"use client";

import { c as _c } from "react/compiler-runtime";
import { IconSearch } from "@tabler/icons-react";
import Link from "next/link";
import { trackPopularSearchClicked } from "@/lib/analytics/segment";
import type { PopularSearchEntry } from "@/lib/contentful/popularSearches";
import { usePopularSearches } from "@/queries/usePopularSearches";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
import { SearchSectionSkeleton } from "./SearchSectionSkeleton";
function resolveDestination(entry: PopularSearchEntry): string {
  if (entry.destinationUrl) return entry.destinationUrl;
  const slug = entry.destinationPage?.fields.slug;
  if (slug) return `/${slug}`;
  return `/products?q=${encodeURIComponent(entry.term)}`;
}
export function PopularSearchesList() {
  const $ = _c(9);
  const close = useSearchPanelStore(_temp);
  const {
    data,
    isLoading,
    isError
  } = usePopularSearches();
  if (isError) {
    return null;
  }
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <section className="flex flex-col gap-3"><h3 className="heading-sm">Popular Searches</h3><SearchSectionSkeleton testId="popular-searches-skeleton" /></section>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!data || data.length === 0) {
    return null;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="heading-sm">Popular Searches</h3>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== close || $[3] !== data) {
    let t2;
    if ($[5] !== close) {
      t2 = (entry, index) => <li key={entry.term}><Link href={resolveDestination(entry)} onClick={() => {
          trackPopularSearchClicked({
            term: entry.term,
            position: index
          });
          close();
        }} className="flex items-center gap-2 rounded-md py-2 text-sm font-normal text-foreground no-underline! hover:opacity-100!"><IconSearch className="size-4 text-muted-foreground" /><span>{entry.term}</span></Link></li>;
      $[5] = close;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = data.map(t2);
    $[2] = close;
    $[3] = data;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <section className="flex flex-col gap-3">{t0}<ul className="flex flex-col">{t1}</ul></section>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(state) {
  return state.close;
}